import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  margin-left: -', 'px;\n  width: 100%;\n\n  ', ';\n'], ['\n  display: flex;\n  flex-direction: column;\n  margin-left: -', 'px;\n  width: 100%;\n\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n          display: flex;\n          flex: 0 1 auto;\n          max-width: 100%;\n        '], ['\n          display: flex;\n          flex: 0 1 auto;\n          max-width: 100%;\n        ']);

import styled, { css } from 'styled-components';
import { gridSize } from '@atlaskit/theme';

var RootWrapper = styled.div(_templateObject, gridSize, function (props) {
  return !props.isEditing ? css(_templateObject2) : null;
});

RootWrapper.displayName = 'RootWrapper';

export default RootWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/inline-edit/dist/esm/styled/RootWrapper.js
// module id = 5968
// module chunks = 0